import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-24 bg-slate-950 text-slate-300 overflow-hidden">
      <div className="h-1 w-full" style={{ background: "linear-gradient(90deg,#DE0F72,#FF9900)" }} />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-2 gap-10">
        <div>
          <img src="/logos/Logotype_WHITE.svg" alt="Ariovis" className="h-7 w-auto mb-5" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
            Pure-player IAM européen. L'identité est devenue le centre de gravité du monde numérique.
            Nous transformons la complexité des accès en maîtrise.
          </p>
          <div className="mt-6 flex items-center gap-4 text-xs">
            <Link to="/mentions-legales" data-testid="footer-legal" className="text-slate-400 hover:text-white transition">
              Mentions légales & confidentialité
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-start md:items-end justify-between gap-6">
          <div className="w-full md:w-auto md:text-right">
            <div className="text-[11px] tracking-[0.18em] uppercase text-slate-500 mb-4">Contact</div>
            <a
              href="https://ariovis.fr/contact"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-contact-link"
              className="group inline-flex items-center gap-2 text-base font-semibold text-white hover:text-fuchsia-400 transition"
            >
              ariovis.fr/contact
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <div className="text-xs text-slate-500 mt-2">
              Échangeons sur votre projet IAM.
            </div>
          </div>
          <div className="text-xs text-slate-500 md:text-right">
            © {new Date().getFullYear()} Ariovis · Security Meets Business
          </div>
        </div>
      </div>
    </footer>
  );
}
